// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.container {
  background-color: var(--background-color);
  padding: 13px 18px 32px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
}
.header .title {
  font-family: AppFontBold;
  font-size: 20px;
  line-height: 17px;
  text-align: center;
  color: #000000;
}
.header .cross {
  height: 18px;
  width: 18px;
  cursor: pointer;
}

.info {
  padding: 0 2px 0 1px;
  font-family: AppFontNormal, sans-serif;
  font-size: 17px;
  line-height: 21px;
  text-align: left;
  color: #2c2c31;
  margin: 20px 0 60px;
  word-break: keep-all;
  font-weight: bolder;
}
@media (min-width: 991px) {
  .info {
    padding: 0px 40px 0px 1px;
  }
}

.buttons {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.buttons .button {
  cursor: pointer;
  width: 100%;
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: AppFontBold;
  font-size: 18px;
  line-height: 15px;
  text-align: center;
  text-transform: uppercase;
  border-radius: 35px;
}
.buttons .button_main {
  background-color: var(--ion-color-primary);
  color: var(--background-color);
  margin-bottom: 10px;
}
.buttons .button_close {
  background-color: transparent;
  color: #000000;
  border: 1px solid #000000;
}

.separator {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.separator .line {
  height: 8px;
  background-image: url('dot.svg');
  background-size: 7px 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/map-location-modal/map-location-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,cAAA;AADD;;AAIA;EACC,yCAAA;EACA,uBAAA;AADD;;AAIA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AADD;AAGC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EAEA,kBAAA;EACA,cAAA;AAFF;AAKC;EACC,YAAA;EACA,WAAA;EACA,eAAA;AAHF;;AAOA;EACC,oBAAA;EACA,sCAAA;EACA,eAAA;EACA,iBAAA;EAEA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;AALD;ACrCE;EDgCF;IAYE,yBAAA;EAHA;AACF;;AAMA;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAHD;AAKC;EACC,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,wBAAA;EACA,eAAA;EACA,iBAAA;EAEA,kBAAA;EACA,yBAAA;EACA,mBAAA;AALF;AAQC;EACC,0CAAA;EACA,8BAAA;EACA,mBAAA;AANF;AASC;EACC,6BAAA;EACA,cAAA;EACA,yBAAA;AAPF;;AAWA;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AARD;AAUC;EACC,WAAA;EACA,gCAAA;EACA,yBAAA;AARF","sourcesContent":["@import '../../../theme/mixins';\n\n:host {\n\tdisplay: block;\n}\n\n.container {\n\tbackground-color: var(--background-color);\n\tpadding: 13px 18px 32px;\n}\n\n.header {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tmargin-bottom: 25px;\n\n\t.title {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 20px;\n\t\tline-height: 17px;\n\n\t\ttext-align: center;\n\t\tcolor: #000000;\n\t}\n\n\t.cross {\n\t\theight: 18px;\n\t\twidth: 18px;\n\t\tcursor: pointer;\n\t}\n}\n\n.info {\n\tpadding: 0 2px 0 1px;\n\tfont-family: AppFontNormal, sans-serif;\n\tfont-size: 17px;\n\tline-height: 21px;\n\n\ttext-align: left;\n\tcolor: #2c2c31;\n\tmargin: 20px 0 60px;\n\tword-break: keep-all;\n\tfont-weight: bolder;\n\t@include desktop {\n\t\tpadding: 0px 40px 0px 1px;\n\t}\n}\n\n.buttons {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\n\t.button {\n\t\tcursor: pointer;\n\t\twidth: 100%;\n\t\theight: 45px;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 18px;\n\t\tline-height: 15px;\n\n\t\ttext-align: center;\n\t\ttext-transform: uppercase;\n\t\tborder-radius: 35px;\n\t}\n\n\t.button_main {\n\t\tbackground-color: var(--ion-color-primary);\n\t\tcolor: var(--background-color);\n\t\tmargin-bottom: 10px;\n\t}\n\n\t.button_close {\n\t\tbackground-color: transparent;\n\t\tcolor: #000000;\n\t\tborder: 1px solid #000000;\n\t}\n}\n\n.separator {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\n\t.line {\n\t\theight: 8px;\n\t\tbackground-image: url(../../../assets/losteria/dot.svg);\n\t\tbackground-size: 7px 100%;\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n\n// Narrow desktop range — catches the cramped layout users see at 125–150% browser\n// zoom on common screen widths, before the mobile breakpoint takes over.\n@mixin tablet {\n  @media (min-width: 991px) and (max-width: 1399px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
